/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { Form, Input, Button, Select } from "antd";
import {
  updateUser,
  getUser,
} from "../features/cutomers/customerSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { message as msg } from "antd";
import { useParams } from "react-router-dom";

const { Option } = Select;

const EditCustomer = () => {
  const { id } = useParams();
  const [messageApi, contextHolder] = msg.useMessage();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, updating, message, isUpdateSuccess, customer } =
    useSelector((state) => state.customer);
  const [form] = Form.useForm();

  const onFinish = (values) => {
    const data = { ...values };
    data.status = Number(data.status);
    dispatch(updateUser({ id, data }));
  };

  useEffect(() => {
    loadUser();
  }, []);

  useEffect(() => {
    if (customer) {
      form.setFieldsValue({
        first_name: customer.first_name,
        last_name: customer.last_name,
        gender: customer.gender,
        status: customer.status?.toString(),
      });
    }
  }, [customer]);

  useEffect(() => {
    console.log("isError", isError);
    console.log("message", message);
    console.log("isUpdateSuccess", isUpdateSuccess);
    console.log("customer", customer);
    if (isError && message) {
      messageApi.open({
        type: "error",
        content: message,
      });
    }

    if (isUpdateSuccess) {
      messageApi.open({
        type: "success",
        content: "User is updated successfully",
      });
      navigate("/admin/customers");
    }
  }, [isError, message, isUpdateSuccess, messageApi, navigate]);

  const loadUser = () => {
    dispatch(getUser(id));
  };

  return (
    <div>
      {contextHolder}
      <h3 className="mb-4 title">Edit User</h3>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          label="First Name"
          name="first_name"
          rules={[{ required: true, message: "Please input the first name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Last Name"
          name="last_name"
          rules={[{ required: true, message: "Please input the last name!" }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          label="Gender"
          name="gender"
          rules={[{ required: true, message: "Please select the gender!" }]}
        >
          <Select>
            <Option value="male">Male</Option>
            <Option value="female">Female</Option>
          </Select>
        </Form.Item>
        
        <Form.Item
          label="Status"
          name="status"
          rules={[{ required: true, message: "Please select the status!" }]}
        >
          <Select>
            <Option value="1">Active</Option>
            <Option value="2">Inactive</Option>
          </Select>
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" disabled={updating}>
            {updating ? "Submitting..." : "Submit"}
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default EditCustomer;
